import React from 'react'
import styled from 'styled-components'
import Image from '../basic/image'
import * as media from '../media'
import OptPrincip from '../finwhale/common/opt-princip'
import BecomePartnerModal from '../finwhale/common/become-partner-request/modal'
import {withState} from 'recompose'
import Button from '../basic/button'
import CatalogueRU from '../static/docs/catalogue-ru.pdf';
import CatalogueRuPreview from '../static/docs/catalogue-ru-preview.png';
import CatalogueUA from '../static/docs/catalogue_ua_finwhale_2023.pdf'
import CatalogueUaPreview from '../static/docs/catalogue_ua_finwhale_2023_preview.png'
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const Header = styled.div`
  margin-top: 40px;
  font-size: 24px;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const Description = styled.div`
  display: flex;
  margin-top: 40px;
  ${media.smallerThan(900)` flex-direction: column-reverse; align-items: center;`}
`

const A = styled.a`
  ${props => props.active
  ? 'background: #0054ff; color: #fff; cursor: auto;'
  : 'cursor: pointer; background: #fff; color: #0054ff; span { border-bottom: 1px dashed; } &:hover { color: red; }'
  }
  padding: 26px 34px;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  text-decoration: none;
  display: inline-block;
  transition: all .3s ease;
  color: #173DB0;
  
`

const OptHeader = styled.div`
  font-size: 24px;
  text-align: left;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 25px;
  width: 80%;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center; margin-bottom: 0;margin-top: 25px;`}
`

const CataloguesHeader = styled.div`
  font-size: 24px;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const CatalogueBody = styled.div`
  margin-top: 40px;
  fontWeight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const Container = styled.div`
  ${media.smallerThan(700)` text-align:center;`}
`

const partners = ({distributors, loading, modalOpened, setModalOpened}) => (
  <CurrentLanguageContext.Consumer>
    {currentLanguage => {
      let email = null;
      switch (currentLanguage) {
        case 'en':
          email = 'info@finwhale.eu';
          break;
        case 'ua':
          email = 'partners.fnw@gmail.com';
          break;
        case 'ru':
          email = 'postavka@finwhale.ru';
          break;
        default:
          email = 'postavka@finwhale.ru';
      }
      return (
        <div>
          {navigator.userAgent !== "ReactSnap" &&
            <div dangerouslySetInnerHTML={{__html:
              `<!--
              Start of Floodlight Tag: Please do not remove
              Activity name of this tag: finwhale.ru_partners
              URL of the webpage where the tag is expected to be placed: 
              This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
              Creation Date: 03/20/2019
              -->
              <script type="text/javascript">
              var axel = Math.random() + "";
              var a = axel * 10000000000000;
              document.write('<iframe src="https://9257786.fls.doubleclick.net/activityi;src=9257786;type=invmedia;cat=finwh00;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=[SessionID]?" width="1" height="1" frameborder="0" style={{display:'none'}}></iframe>');
              </script>
              <noscript>
              <iframe src="https://9257786.fls.doubleclick.net/activityi;src=9257786;type=invmedia;cat=finwh00;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=[SessionID]?" width="1" height="1" frameborder="0" style={{display:'none'}}></iframe>
              </noscript>
              <!-- End of Floodlight Tag: Please do not remove -->`
            }}/>
          }

          <div style={{width: '80%', margin: '0 auto', fontSize: '18px'}}>
            <Header>
              <TranslateText id="partners__header"/>
            </Header>
            <Description>
              <p
                style={{
                  fontSize: '16px',
                  flexGrow: 1,
                  flexShrink: 1,
                }}
              >
                <Container>
                  <TranslateText
                    id={"partners__text"}
                    useHtml
                  />
                </Container>
                <Container>
                  <A href={`mailto:${email}`}>
                    <TranslateText id="partners__write_to_us"/>
                  </A>
                </Container>
              </p>
            </Description>
          </div>

          <OptHeader>
            <TranslateText id="partners__opt_deliveries"/>
          </OptHeader>

          <OptPrincip/>

          <div
            style={{
              marginTop: 20,
              textAlign: 'center',
            }}
          >
            <TranslateText
              id="partners__become_partner"
              place="bottom"
              style={{ display: 'inline-block' }}
              render={text => {
                return (
                  <Button onClick={() => setModalOpened(!modalOpened)}>
                    {text}
                  </Button>
                );
              }}
            />
          </div>
          <div
            style={{
              width: '80%',
              margin: 'auto',
              marginTop: 40,
            }}
          >
            <CataloguesHeader>
              <TranslateText id="partners__catalogues"/>
            </CataloguesHeader>
            <CatalogueBody>
              <a href={currentLanguage !== 'ua' ? CatalogueRU : CatalogueUA} download>
                <Image
                  src={currentLanguage !== 'ua' ? CatalogueRuPreview : CatalogueUaPreview}
                  width={200}
                />
              </a>
            </CatalogueBody>
          </div>
          {modalOpened && <BecomePartnerModal toggle={() => setModalOpened(!modalOpened)}/>}
        </div>
      );
    }}
  </CurrentLanguageContext.Consumer>
)

export default withState('modalOpened', 'setModalOpened', false)(partners)



// WEBPACK FOOTER //
// ./src/pages/partners.js